export type QRPairModel = { questionId: string; rowOrder: string }

export const extractQRValues = (formula: string) => {
  const qrPairs: QRPairModel[] = []
  const singleQValues: string[] = []
  const singleRValues: string[] = []

  const combinedRegex = /QR(\d+)_(\d+)|Q(\d+)|R(\d+)/g

  const matches = formula.matchAll(combinedRegex)

  for (const match of matches) {
    if (match[1] && match[2]) {
      qrPairs.push({
        questionId: match[1],
        rowOrder: match[2],
      })
    } else if (match[3]) {
      singleQValues.push(`Q${match[3]}`)
    } else if (match[4]) {
      singleRValues.push(`R${match[4]}`)
    }
  }

  return {
    qrPairs: [...new Set(qrPairs)],
    qValues: [...new Set(singleQValues)],
    rValues: [...new Set(singleRValues)],
  }
}
